import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  loader: any;
  loader_sub: any;

  constructor() {
    this.loader = document.querySelector('#progress_loading');
    this.loader_sub = document.querySelector('#progress_loading>#fuse-splash-screen');
  }

  public show(): void {
    if (this.loader) {
      this.loader.style.display = 'block';
      this.loader_sub.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      this.loader_sub.style.pointerEvents = 'all';
    }
  }
  public hide(): void {
    if (this.loader) {
      this.loader.style.display = 'none';
    }
  }

}
